
import React, { useState } from "react";
import { Typography, Button, FormControl, FormLabel, FormControlLabel, Radio, RadioGroup, Grid, Dialog, DialogActions, TextField, DialogContent, DialogTitle, Box } from "@mui/material";
import styles from '../../PreAuthForms/PreAuthForms/FormAuth.module.css';
import { Controller, useForm } from "react-hook-form";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";


const LiquidOxygenSystem = ({ handleClose, preAuthFormData }) => {


    const { control } = useForm();
    const { t } = useTranslation();

    return (
        <div>
            <Dialog fullWidth maxWidth="md" open={true} onClose={handleClose} >
                <DialogTitle sx={{ m: 0, p: 2 }} className={styles.DialogTitle}>
                    {t("PreAuthForm.liquidOxygenSystemFormTitle")}
                </DialogTitle>


                <DialogContent>
                    <Typography sx={{ margin: '10px 0px' }}>
                        <span className={styles.asterisk}>*</span> { t("PreAuthForm.requiredField") }
                    </Typography>

                    {
                        preAuthFormData[0]?.BranchCode !== undefined && preAuthFormData[0].BranchCode !== '' &&
                        <Grid container>
                            <Grid xs={12} md={6} >
                                <FormControl className={styles.spacingRemoveTop}>
                                    <div>
                                        <Typography sx={{ margin: '10px 0px' }} className={styles.labelText}>
                                            {t("PreAuthForm.branchCode")} <span className={styles.asterisk}> *</span>
                                        </Typography>
                                    </div>
                                    <div >
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            autoFocus
                                            variant="outlined"
                                            id="name"
                                            type="text"
                                            value={preAuthFormData[0].BranchCode}
                                            disabled={true}
                                            sx={{
                                                marginTop: '5px',
                                                resize: 'verical',
                                                overflow: 'auto',
                                                maxHeight: '300px',
                                                backgroundColor: "var(--color-disableField)",
                                                borderRadius: "8px",
                                                '& .Mui-disabled': {
                                                    '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                                },
                                            }}
                                            inputProps={{
                                                style: {
                                                    cursor: 'not-allowed'
                                                }
                                            }}
                                        />
                                    </div>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.IsPatientOnLiquidOxygenSystem !== undefined &&
                        <Grid container >
                            <Grid xs={12} className={styles.spacingTop}>
                                <FormControl className={styles.spacingRemoveTop}>
                                    <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                        1. {t("PreAuthForm.IsPatientOnLiquidOxygenSystem")}<span className={styles.asterisk}> *</span>
                                    </FormLabel>
                                    <RadioGroup
                                        value={preAuthFormData[0].IsPatientOnLiquidOxygenSystem}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        className='paddingLeftFifteenpx'
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                        <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} sx={{ cursor: 'not-allowed' }} />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.IsLiquidOxygenRefill !== undefined &&
                        <Grid container sx={{ paddingLeft: '15px' }}>
                            <Grid xs={12} className={styles.spacingTop}>
                                <FormControl className={styles.spacingRemoveTop}>
                                    <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                        a. {t("PreAuthForm.isThisRefill")} <span className={styles.asterisk}>*</span>
                                    </FormLabel>
                                    <RadioGroup
                                        value={preAuthFormData[0].IsLiquidOxygenRefill}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        className='paddingLeftFifteenpx'
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} />
                                        <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }


                    {
                        preAuthFormData[0]?.ClinicalRationaleLiquidOxygen !== undefined && preAuthFormData[0].ClinicalRationaleLiquidOxygen !== '' &&
                        <Grid container sx={{ paddingLeft: '15px' }}>
                            <Grid xs={12} className={styles.spacingTop}>
                                <div>
                                    <Typography className={styles.labelText}>
                                        b. {t("PreAuthForm.liquidRationale")}
                                    </Typography>
                                </div>
                                <TextField
                                    fullWidth
                                    aria-label="minimum height"
                                    minRows={3}
                                    multiline
                                    rows={3}
                                    size="small"
                                    value={preAuthFormData[0].ClinicalRationaleLiquidOxygen}
                                    disabled={true}
                                    sx={{
                                        marginTop: '5px',
                                        resize: 'verical',
                                        overflow: 'auto',
                                        maxHeight: '300px',
                                        backgroundColor: "var(--color-disableField)",
                                        borderRadius:'8px',
                                        '& .Mui-disabled': {
                                            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                        },
                                    }}
                                    inputProps={{
                                        style: {
                                            cursor: 'not-allowed'
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.IsPhysicianOrder !== undefined &&
                        <Grid container>
                            <Grid xs={12} className={styles.spacingTop}>
                                <FormControl className={styles.spacingRemoveTop}>
                                    <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label"> 
                                        2. {t("PreAuthForm.physicianOrder")} <span className={styles.asterisk}> *</span>
                                    </FormLabel>
                                    <Box component="span" sx={{ fontWeight: 'bold', fontStyle: "italic", marginLeft: '18px', marginTop:'4px' }}>
                                        {t('PreAuthForm.mdOrder')}
                                    </Box>
                                    <RadioGroup
                                        value={preAuthFormData[0].IsPhysicianOrder}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        className='paddingLeftFifteenpx'
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} />
                                        <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.IsHighFlowOxygenNeeds !== undefined &&
                        <Grid container>
                            <Grid xs={12} className={styles.spacingTop}>
                                <FormControl className={styles.spacingRemoveTop}>
                                    <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                        3. {t("PreAuthForm.highFlowOxygenNeeds")}<span className={styles.asterisk}> *</span>
                                    </FormLabel>
                                    <RadioGroup
                                        value={preAuthFormData[0].IsHighFlowOxygenNeeds}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        className='paddingLeftFifteenpx'
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} />
                                        <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.IsApprovalHighFlowOxygen !== undefined &&
                        <Grid container sx={{ paddingLeft: '15px' }}>
                            <Grid xs={12} className={styles.spacingTop}>
                                <FormControl className={styles.spacingRemoveTop}>
                                    <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                        a. {t("PreAuthForm.NmdName")}</FormLabel>
                                    <RadioGroup
                                        value={preAuthFormData[0]?.IsApprovalHighFlowOxygen}
                                        disabled={true}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        sx={{ paddingLeft: '15px' }}
                                    >

                                        <Grid container direction="column">
                                            <Grid item>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} />
                                                <Grid container>
                                                    <Grid xs={12} md={6} sx={{ paddingLeft: '15px' }}>
                                                        <div>
                                                            <Typography className={styles.labelText}>
                                                                {t("PreAuthForm.medicalDirectorName")}
                                                            </Typography>
                                                        </div>
                                                        <TextField
                                                            fullWidth
                                                            aria-label="Name field"
                                                            minRows={2}
                                                            value={preAuthFormData[0]?.NmdName}
                                                            disabled={true}
                                                            size="small"
                                                            sx={{
                                                                marginTop: '5px',
                                                                resize: 'verical',
                                                                overflow: 'auto',
                                                                maxHeight: '300px',
                                                                backgroundColor: "var(--color-disableField)",
                                                                borderRadius: "8px",
                                                                '& .Mui-disabled': {
                                                                    '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                                                },
                                                            }}
                                                            inputProps={{
                                                                style: {
                                                                    cursor: 'not-allowed'
                                                                }
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid xs={12} md={6} sx={{ paddingLeft: '15px' }}>
                                                        <div>
                                                            <Typography className={styles.labelText}>
                                                                {t("PreAuthForm.approvalDate")}
                                                            </Typography>
                                                        </div>
                                                        <Controller
                                                            name="NmdApprovalDate"
                                                            control={control}
                                                            rules={{ required: true }}
                                                            render={({ field }) => (
                                                                <LocalizationProvider dateAdapter={AdapterDayjs} >
                                                                    <DatePicker slotProps={{ textField: { fullWidth: true, variant: 'outlined' } }} sx={{
                                                                        '& .MuiInputBase-input': {
                                                                            height: '10px',
                                                                        },
                                                                        backgroundColor: 'var(--color-disableField)',
                                                                        borderRadius: "8px",
                                                                        marginTop:"3px",
                                                                        '& .Mui-disabled': {
                                                                            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                                                        },
                                                                    }} name={field.name} value={dayjs(field.value)} inputRef={field.ref}  disabled={true} />
                                                                </LocalizationProvider>
                                                            )}
                                                        />
                                                    </Grid>

                                                </Grid>

                                            </Grid>
                                            <Grid item>
                                                <FormControlLabel value="false" control={<Radio />} label="No (Approval must be obtained before submission of this form.)" disabled={true} />
                                            </Grid>
                                        </Grid>

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.CurrentLiterFlowOrdered &&
                        <Grid container>
                            <Grid xs={12} className={styles.spacingTop}>
                                <div>
                                    <Typography className={styles.labelText}>
                                        4. {t("PreAuthForm.currentLiterFlow")}<span className={styles.asterisk}> *</span>
                                    </Typography>
                                </div>
                                <TextField
                                    fullWidth
                                    aria-label="liter flow field"
                                    minRows={2}
                                    value={preAuthFormData[0]?.CurrentLiterFlowOrdered}
                                    disabled={true}
                                    size="small"
                                    sx={{
                                        marginTop: '5px',
                                        resize: 'verical',
                                        overflow: 'auto',
                                        maxHeight: '300px',
                                        backgroundColor: "var(--color-disableField)",
                                        borderRadius: "8px",
                                        '& .Mui-disabled': {
                                            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                        },
                                    }}
                                    inputProps={{
                                        style: {
                                            cursor: 'not-allowed'
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.IsPatientAmbulatory !== undefined &&
                        <Grid container>
                            <Grid xs={12} className={styles.spacingTop}>
                                <FormControl className={styles.spacingRemoveTop}>
                                    <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                        5. {t("PreAuthForm.IsThePatientAmbulatory")}<span className={styles.asterisk}> *</span>
                                    </FormLabel>
                                    <RadioGroup
                                        value={preAuthFormData[0]?.IsPatientAmbulatory}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        className='paddingLeftFifteenpx'
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} />
                                        <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.Pps &&
                        <Grid container sx={{ paddingLeft: '15px' }}>
                            <div>
                                <Grid xs={12} className={styles.spacingTop} sx={{ paddingLeft: '10px' }}>
                                    <div>
                                        <Typography className={styles.labelText}>
                                            a. {t("PreAuthForm.pps")}<span className={styles.asterisk}> *</span>
                                        </Typography>
                                    </div>
                                    <TextField
                                        fullWidth
                                        aria-label="minimum height"
                                        rows={3}
                                        size="small"
                                        value={preAuthFormData[0]?.Pps}
                                        disabled={true}
                                        sx={{
                                            marginTop: '5px',
                                            resize: 'verical',
                                            overflow: 'auto',
                                            maxHeight: '300px',
                                            backgroundColor: "var(--color-disableField)",
                                            borderRadius: "8px",
                                            '& .Mui-disabled': {
                                                '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                            },
                                        }}
                                        inputProps={{
                                            style: {
                                                cursor: 'not-allowed'
                                            }
                                        }}
                                    />
                                </Grid>

                                <Grid xs={12} className={styles.spacingTop} sx={{ paddingLeft: '10px' }}>
                                    <div>
                                        <Typography className={styles.labelText}>
                                            b. {t("PreAuthForm.nyhaClass")}<span className={styles.asterisk}> *</span>
                                        </Typography>
                                    </div>
                                    <TextField
                                        fullWidth
                                        aria-label="minimum height"
                                        rows={3}
                                        size="small"
                                        value={preAuthFormData[0]?.NyhaClass}
                                        disabled={true}
                                        sx={{
                                            marginTop: '5px',
                                            resize: 'verical',
                                            overflow: 'auto',
                                            maxHeight: '300px',
                                            backgroundColor: "var(--color-disableField)",
                                            borderRadius: "8px",
                                            '& .Mui-disabled': {
                                                '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                            },
                                        }}
                                        inputProps={{
                                            style: {
                                                cursor: 'not-allowed'
                                            }
                                        }}
                                    />
                                </Grid>
                            </div>

                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.OtherExtenuatingCircumstances &&
                        <Grid container>
                            <Grid xs={12} className={styles.spacingTop}>
                                <FormLabel className={`${styles.labelText} displayFlex`} id="demo-row-radio-buttons-group-label">
                                    <div>6.&nbsp;</div>
                                    <div>
                                        {t("PreAuthForm.extenuatingCircumstancesForLiquidOxygen")}<span className="asteriskSignColor"> *</span>
                                    </div>
                                </FormLabel>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    size="small"
                                    value={preAuthFormData[0]?.OtherExtenuatingCircumstances}
                                    disabled={true}
                                    aria-label="minimum height"
                                    sx={{
                                        marginTop: '5px',
                                        resize: 'verical',
                                        overflow: 'auto',
                                        maxHeight: '300px',
                                        backgroundColor: "var(--color-disableField)",
                                        borderRadius: "8px",
                                        '& .Mui-disabled': {
                                            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                        },
                                    }}
                                    inputProps={{
                                        style: {
                                            cursor: 'not-allowed'
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.IsFacilityRequested !== undefined &&
                        <Grid container>
                            <Grid xs={12} className={styles.spacingTop}>
                                <FormControl className={styles.spacingRemoveTop}>
                                    <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                        7. {t("PreAuthForm.facilityRequested")}<span className={styles.asterisk}> *</span></FormLabel>
                                    <RadioGroup
                                        value={preAuthFormData[0]?.IsFacilityRequested}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        className='paddingLeftFifteenpx'
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} />
                                        <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.IsFacilityRequired !== undefined &&
                        <Grid container sx={{ paddingLeft: '15px' }}>
                            <Grid xs={12} className={styles.spacingTop}>
                                <FormControl className={styles.spacingRemoveTop}>
                                    <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                        a. {t("PreAuthForm.facilityRequired")}
                                    </FormLabel>
                                    <RadioGroup
                                        value={preAuthFormData[0]?.IsFacilityRequired}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        className='paddingLeftFifteenpx'
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} />
                                        <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.FacilityRequestingName &&
                        <Grid container sx={{ paddingLeft: '15px' }}>
                            <Grid xs={12} className={styles.spacingTop}>
                                <div>
                                    <Typography className={styles.labelText}>
                                        b. {t("PreAuthForm.requestingFacilityName")}<span className="asteriskSignColor"> *</span>
                                    </Typography>
                                </div>
                                <TextField
                                    minRows={2}
                                    aria-label="requesting custom text"
                                    size="small"
                                    fullWidth
                                    value={preAuthFormData[0]?.FacilityRequestingName}
                                    disabled={true}
                                    sx={{
                                        marginTop: '5px',
                                        resize: 'verical',
                                        overflow: 'auto',
                                        maxHeight: '300px',
                                        backgroundColor: "var(--color-disableField)",
                                        borderRadius: "8px",
                                        '& .Mui-disabled': {
                                            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                        },
                                    }}
                                    inputProps={{
                                        style: {
                                            cursor: 'not-allowed'
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.ClinicianName && <Grid container>
                            <Grid xs={12} className={styles.spacingTop}>
                                <div>
                                    <Typography className={styles.labelText}>
                                        {t("PreAuthForm.clinicalName")}<span className={styles.asterisk}> *</span>
                                    </Typography>
                                </div>
                                <TextField
                                    aria-label="clinic text field"
                                    value={preAuthFormData[0]?.ClinicianName}
                                    disabled={true}
                                    fullWidth
                                    minRows={2}
                                    size="small"
                                    sx={{
                                        marginTop: '5px',
                                        resize: 'verical',
                                        overflow: 'auto',
                                        maxHeight: '300px',
                                        backgroundColor: "var(--color-disableField)",
                                        borderRadius: "8px",
                                        '& .Mui-disabled': {
                                            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                        },
                                    }}
                                    inputProps={{
                                        style: {
                                            cursor: 'not-allowed'
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.AdministratorOrED && <Grid container>
                            <Grid xs={12} className={styles.spacingTop}>
                                <div>
                                    <Typography className={styles.labelText}>
                                        {t("PreAuthForm.edAdmin")}<span className={styles.asterisk}> *</span>
                                    </Typography>
                                </div>
                                <TextField
                                    fullWidth
                                    aria-label="Admin field"
                                    minRows={2}
                                    value={preAuthFormData[0]?.AdministratorOrED}
                                    disabled={true}
                                    size="small"
                                    sx={{
                                        marginTop: '5px',
                                        resize: 'verical',
                                        overflow: 'auto',
                                        maxHeight: '300px',
                                        backgroundColor: "var(--color-disableField)",
                                        borderRadius: "8px",
                                        '& .Mui-disabled': {
                                            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                        },
                                    }}
                                    inputProps={{
                                        style: {
                                            cursor: 'not-allowed'
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    }

                    {
                        preAuthFormData[0]?.AVPO && <Grid container>
                            <Grid xs={12} className={styles.spacingTop}>
                                <div>
                                    <Typography className={styles.labelText}>
                                        {t("PreAuthForm.avpo")}<span className={styles.asterisk}> *</span>
                                    </Typography>
                                </div>
                                <TextField
                                    fullWidth
                                    aria-label="avpo field"
                                    minRows={2}
                                    value={preAuthFormData[0]?.AVPO}
                                    disabled={true}
                                    size="small"
                                    sx={{
                                        marginTop: '5px',
                                        resize: 'verical',
                                        overflow: 'auto',
                                        maxHeight: '300px',
                                        backgroundColor: "var(--color-disableField)",
                                        borderRadius: "8px",
                                        '& .Mui-disabled': {
                                            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                        },
                                    }}
                                    inputProps={{
                                        style: {
                                            cursor: 'not-allowed'
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    }
                </DialogContent>

                <Grid container sx={{ justifyContent: 'end' }}>
                    <Grid>
                        <DialogActions style={{ padding: "14px 16px", justifyContent: "end" }} >
                            <Button
                                onClick={handleClose}
                                color='secondary'
                            >
                                {t('NewOrder.close')}
                            </Button>
                        </DialogActions>
                    </Grid>
                </Grid>

            </Dialog>
        </div>
    )
}

export default LiquidOxygenSystem;